export const R = {
	"title": "Vælg hvem du booker for",
	"subtitle": "Når du vælger et barn, bliver det tilføjet til din profil og du fortsætter i bookingen.",
	"buttonCreateManually": "Tilføj manuelt",
	"buttonInviteManually": "Inviter manuelt"
}